import { Link } from 'react-router-dom';

const divisions = [
  {
    to: '/bookkeeping',
    name: 'Penland Bookkeeping',
    icon: 'ri-book-3-line',
    tag: 'Bookkeeping & Financial',
    desc: 'Bookkeeping, tax filings, and financial reporting for Richmond-area restaurants, skilled trades, small businesses, and nonprofits, plus operations consulting, web development and technology, small project management, and event and program management for the same clients.',
  },
  {
    to: '/consulting',
    name: 'Consulting & Web Development',
    icon: 'ri-code-s-slash-line',
    tag: 'Consulting & Technology',
    desc: 'Operations consulting and leadership, financial consulting, web development, event and program management, and small project management, provided by Penland LLC under its own name.',
  },
  {
    to: '/properties',
    name: 'Penland Properties',
    icon: 'ri-home-4-line',
    tag: 'Property Management',
    desc: 'Management of long-term and short-term residential rentals, covering leasing, bookings, maintenance, repairs, and property tax.',
  },
  {
    to: '/matchlineup',
    name: 'MatchLineup',
    icon: 'ri-calendar-event-line',
    tag: 'Software',
    desc: 'Match scheduling for adult recreational tennis teams.',
  },
  {
    to: 'https://alabastertravel.com/',
    external: true,
    name: 'Alabaster Travel',
    icon: 'ri-plane-line',
    tag: 'Travel Advisory',
    desc: 'Independent travel advisory, covering itinerary design, booking, and concierge support.',
  },
];

export default function DivisionsSection() {
  return (
    <section id="divisions" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12 md:mb-16">
            <p className="text-accent-600 text-sm font-semibold tracking-widest uppercase mb-3">
              Our Divisions
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-primary-950 max-w-3xl leading-tight">
              Five divisions.
              <span className="italic text-accent-600"> One point of accountability.</span>
            </h2>
            <p className="text-foreground-600 text-base md:text-lg max-w-2xl mt-4 leading-relaxed">
              Each division operates under its own name and serves its own clients. Follow the
              one you need.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
            {divisions.map((div) => {
              const cardClass =
                'group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-accent-300/50 hover:shadow-lg transition-all flex flex-col';
              const inner = (
                <div className="p-5 md:p-6 flex flex-col flex-1">
                  <div className="flex items-center justify-between gap-3 mb-4">
                    <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center shrink-0">
                      <i className={`${div.icon} text-accent-600 text-xl`} />
                    </div>
                    <span className="inline-flex items-center bg-accent-100 text-accent-700 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {div.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-lg md:text-xl text-primary-950 font-semibold mb-2 leading-snug">
                    {div.name}
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed flex-1">
                    {div.desc}
                  </p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-accent-600 group-hover:text-accent-500 text-sm font-semibold">
                    {div.external ? 'Visit site' : 'Visit page'}
                    <i
                      className={
                        div.external
                          ? 'ri-external-link-line'
                          : 'ri-arrow-right-line group-hover:translate-x-1 transition-transform'
                      }
                    />
                  </span>
                </div>
              );

              return div.external ? (
                <a
                  key={div.to}
                  href={div.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={cardClass}
                >
                  {inner}
                </a>
              ) : (
                <Link key={div.to} to={div.to} className={cardClass}>
                  {inner}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}